import React from 'react';

const PermissionProvider = React.createContext<[any, any]>([{}, {}]);

export default PermissionProvider;